"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Header_1 = require("./Header");

var Main_1 = require("./Main");

var Footer_1 = require("./Footer");

var Element_1 = require("./Element");

var Routes_1 = require("./Routes");

var styled_1 = __importDefault(require("@emotion/styled"));

var StyledLayout = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));

exports.Layout = function (_a) {
  var tenant = _a.tenant,
      layout = _a.layout;
  return layout ? react_1.default.createElement(StyledLayout, null, layout.elements && layout.elements.map(function (element) {
    return react_1.default.createElement(Element_1.Element, {
      key: element.id,
      tenant: tenant,
      element: element,
      root: "Layout"
    });
  })) : react_1.default.createElement(StyledLayout, null, react_1.default.createElement(Header_1.Header, null), react_1.default.createElement(Main_1.Main, null, react_1.default.createElement(Routes_1.Routes, null)), react_1.default.createElement(Footer_1.Footer, null));
};

var templateObject_1;